(ns frontend.view.components.switch-toggle
  (:require [frontend.utils :as fu]))

(defn view [{:keys [class-name options disable-all?]}]
  [:div
   {:class "py-2 flex justify-cenyter"}
   ;;TODO general class-names instead of filter-mode specific
   [:div
    {:class-name (fu/cs "filter-mode-switch"
                        class-name)}
    (doall
     (for [[i option] (map-indexed vector options)
           :let [{:keys [key label selected? disabled? on-select!]} option
                 disabled? (or disabled? disable-all?)]]
       ^{:key (str "switch-option-" (or key i))}
       [:span
        {:class-name (fu/cs "filter-mode"
                            (when selected?
                              "selected")
                            (when (or disable-all?
                                      disabled?)
                              "disabled"))
         :on-click   (fn [_]
                       (when-not disabled?
                         (on-select!)))}
        [:span label]]))]])
